import { faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Modal, ModalContent } from '@pickleballinc/react-ui';
import { useState } from 'react';

import { bettingSiteSvgs } from './constants';
import { SVGBettingSiteOther } from './SVGBettingSites';

interface BettingModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	bettingSite: string;
	pickleballImage: string;
}

export function BettingModal({ open, onClose, onConfirm, bettingSite = 'the betting site', pickleballImage }: BettingModalProps) {
	const [isChecked, setIsChecked] = useState(false);

	const SVGComponent = bettingSiteSvgs[bettingSite] || SVGBettingSiteOther;

	return (
		<Modal open={open} onOpenChange={onClose}>
			<ModalContent className="flex w-[calc(100%-16px)] flex-col gap-4 !overflow-hidden !p-6 !outline-none md:max-w-[464px]">
				<div className="relative text-center">
					<button
						type="button"
						aria-label="Close"
						className="absolute -right-2 top-0 flex size-6 items-center justify-center rounded-md border border-solid border-gray-300 bg-white p-1 hover:cursor-pointer hover:bg-gray-100"
						onClick={onClose}
					>
						<FontAwesomeIcon icon={faX} className="text-gray-400" height={20} />
					</button>

					<img src={pickleballImage} width={68} height={68} alt="Pickleball.com" />
				</div>
				<div className="flex flex-col gap-2">
					<div className="text-left font-semibold text-lg">You are now leaving pickleball.com</div>
					<div className="text-left text-sm">
						You are leaving pickleball.com and a different terms of use and privacy policy will apply. By proceeding, you agree and
						understand that Pickleball OpCo LLC is not responsible for the site you are about to access.
					</div>
					<Checkbox checked={isChecked} onChange={() => setIsChecked((prev) => !prev)} size="sm" Text={`I understand`} />
					<div className="flex items-center justify-center py-6 w-full">
						<div className="flex items-center justify-center border border-gray-100 rounded-lg w-full p-6">
							<SVGComponent />
						</div>
					</div>
				</div>
				<div className="flex items-center gap-4 justify-between">
					<Button
						variant="secondary"
						className="flex w-[200px] justify-center border !text-sm !text-gray-500 focus:!shadow-[unset]"
						onClick={onClose}
					>
						Cancel
					</Button>

					<Button
						variant="primary"
						className="flex w-[200px] justify-center !text-sm focus:!shadow-[unset]"
						onClick={onConfirm}
						disabled={!isChecked}
					>
						Continue
					</Button>
				</div>
			</ModalContent>
		</Modal>
	);
}
